import { ReactNode, createContext, useEffect, useRef, useState } from 'react';

// ----------------------------------------------------------------------

type WindowDimensionContextProps = {
    windowWidth: number,
    windowHeight: number,
    isResizing: boolean
};

const initialState: WindowDimensionContextProps = {
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
    isResizing: false,
};

const WindowDimensionContext = createContext<WindowDimensionContextProps>(initialState);

type WindowDimensionProviderProps = {
    children: ReactNode;
};

const WindowDimensionProvider = ({ children }: WindowDimensionProviderProps) => {
    const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);
    const [windowHeight, setWindowHeight] = useState<number>(window.innerHeight);
    const [isResizing, setIsResizing] = useState<boolean>(false);

    useEffect(() => {
        function handleResize() {
            setWindowWidth(window.innerWidth);
            setWindowHeight(window.innerHeight);
            setIsResizing(true);
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <WindowDimensionContext.Provider
            value={{
                windowWidth,
                windowHeight,
                isResizing
            }}
        >
            {children}
        </WindowDimensionContext.Provider>
    );
}

export { WindowDimensionProvider, WindowDimensionContext };
